import { render, staticRenderFns } from "./MInquiryCta.vue?vue&type=template&id=636044a4&scoped=true&"
import script from "./MInquiryCta.vue?vue&type=script&lang=js&"
export * from "./MInquiryCta.vue?vue&type=script&lang=js&"
import style0 from "./MInquiryCta.vue?vue&type=style&index=0&id=636044a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636044a4",
  null
  
)

export default component.exports